import { render, staticRenderFns } from "./MobileHeaderGames.vue?vue&type=template&id=1408eff3&scoped=true&"
import script from "./MobileHeaderGames.vue?vue&type=script&lang=js&"
export * from "./MobileHeaderGames.vue?vue&type=script&lang=js&"
import style0 from "./MobileHeaderGames.vue?vue&type=style&index=0&id=1408eff3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1408eff3",
  null
  
)

export default component.exports